import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {XMLHttpRequestHandler} from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {header} from "./header";
import {permalinkSearch_template} from "../components/templates/permalinkSearch_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnAppZone } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone';

declare var ko: any;
declare var page: any;

export class permalinkSearch extends vnModule_knockoutJS{

    protected permalinkSearch_template: permalinkSearch_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected zoneHeader: vnAppZone | null;

    /**
     * @inheritDoc
     */
    protected getModuleName(): string{

        return 'permalinkSearch';
    }


    /**
     * @inheritDoc
     */
    public buildContent() : Array<Element>{

        this.zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = this.zoneHeader?.loadedModule;
        (<header>loadedModule).setHeaderTitle('Page Path Search');

        this.permalinkSearch_template = new permalinkSearch_template('permalinkSearch', this.viewModel, this)
        this.template = this.permalinkSearch_template;

        return [this.permalinkSearch_template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage(): void {

        // scroll to top
        window.scrollTo(0, 0);

        this.permalinkSearch_template.buildDatePickerCalendar();
        this.permalinkSearch_template.setMetricFilterItems();
        
        // First get the presets
        this.getSearchPresetsListData();
    }

    protected getListFormData(): void {

        this.loadingIn(this.permalinkSearch_template.builtTemplate.querySelector("#report-results"));

        let subViewModel = this.permalinkSearch_template.getViewModelForRequest();

        let usrReq_url: string = '/api/permalink_search/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    /**
     * Returns handler for filter request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onFilterRequestReturn(req, obj): Function{

        return function(){

            if(req.request.readyState == 4){
                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    // Every 100 report loads, display the Plan upgrade promotion (to free plan accounts only)
                    obj.zoneHeader?.loadedModule.showPlanPromo();
                    
                    obj.updateFilters(responseParsed);

                    obj.updateViewModelFromPath();

                    obj.getReportStatus();

                    obj.getSampledDates();
                    
                    obj.getPermalinksBySearchByDate();

                    obj.getPermalinksIndicatorsBySearchByDate();

                    obj.permalinkSearch_template.setDatesSelected();
                }
            }

            obj.loadingOut(obj.permalinkSearch_template.builtTemplate.querySelector("#report-results"));
        }
    }

    public getReportStatus(): void{

        let subViewModel = this.permalinkSearch_template.getViewModelForRequest();
        let baseApiUrl = '/api/permalink_search/reportStatus/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onReportStatusRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getReportStatus');
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onReportStatusRequestReturn(req, obj): Function{

        return function(){

            if(req.request.readyState == 4){
                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateReportStatusData(responseParsed);

                }
            }
        }
    }

    public getSampledDates(): void{

        let subViewModel = this.permalinkSearch_template.getViewModelForRequest();
        let baseApiUrl = '/api/permalink_search/sampledDates/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onSampledDatesRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getSampledDates');
    }

    protected onSampledDatesRequestReturn(req, obj): Function{

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateSampledDatesData(responseParsed);

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                }
            }
        }
    }

    protected updateReportStatusData(responseParsed: any): void{

        this.permalinkSearch_template.setReportStatusData(responseParsed.reportStatusData);
    }

    protected updateSampledDatesData(responseParsed: any): void{

        this.permalinkSearch_template.setSampledDatesData(responseParsed.sampledDatesData);
    }

    /**
     * Update the filters.
     *
     * @param responseParsed
     */
    protected updateFilters(responseParsed: any): void{

        this.permalinkSearch_template.setDynamicFilters(responseParsed.dynamicFiltersData);
        this.permalinkSearch_template.setBrandFilterItems(responseParsed.portfolios, responseParsed.hasAllBrands);
        this.permalinkSearch_template.setDefaultDevices();
    }

    public getPermalinksBySearchByDate(): void {

        this.loadingIn(this.permalinkSearch_template.builtTemplate.querySelector("#permalinksBySearchByDate-results"), true);

        let subViewModel = this.permalinkSearch_template.getViewModelForRequest();
        
        let baseApiUrl = '/api/permalink_search/permalinksBySearchByDate/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onPermalinksBySearchByDateRequestReturn.bind(this, baseApiUrl, 'getPermalinksBySearchByDate'), XMLHttpRequestHandler_requestType.GET, 'getPermalinksBySearchByDate');
    }

    public getPermalinksIndicatorsBySearchByDate(): void {

        this.loadingIn(this.permalinkSearch_template.builtTemplate.querySelector("#permalinksIndicatorsBySearchByDate-results"), true);

        this.permalinkSearch_template.clearTimelineAnnotatonData();

        let subViewModel = this.permalinkSearch_template.getViewModelForRequest();
        
        let baseApiUrl = '/api/permalink_search/permalinksIndicatorsBySearchByDate/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onPermalinksIndicatorsBySearchByDateRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getPermalinksIndicatorsBySearchByDate');
    }

    public getListDataForCSV(): void {

        this.loadingIn(this.permalinkSearch_template.builtTemplate.querySelector("#permalinksBySearchByDate-results"));

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.permalinkSearch_template.getViewModelForRequest();
        
        let baseApiUrl = '/api/permalink_search/permalinksBySearchByDateExport/get/';
        
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        
        this.XHRHdl = new XMLHttpRequestHandler(baseApiUrl,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onCSVDataRequestReturn;
        this.XHRHdl.execute();
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onPermalinksBySearchByDateRequestReturn(baseApiUrl, callIdentifier, req, obj): Function{

        return function(){

            if(req.request.readyState == 4){
                
                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    obj.updateRows(responseParsed.data.rows);
                    obj.updateTotalRow(responseParsed.data.totalRow);
                    obj.updatePagination(responseParsed.totalCount);
                    obj.setResultInfo(baseApiUrl, callIdentifier, responseParsed.totalCount, responseParsed.totalPage);
                }
            }

            obj.loadingOut(obj.permalinkSearch_template.builtTemplate.querySelector("#permalinksBySearchByDate-results"), true);
        }
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onPermalinksIndicatorsBySearchByDateRequestReturn(req, obj): Function{

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateIndicatorsData(responseParsed.indicatorsData);
                obj.permalinkSearch_template.setTimelineAnnotationsData(responseParsed.timelineAnnotationsData);
                obj.permalinkSearch_template.updateIndicatorsGraphData();
            });

            obj.loadingOut(obj.permalinkSearch_template.builtTemplate.querySelector("#permalinksIndicatorsBySearchByDate-results"), true);
        };
    }

    protected onCSVDataRequestReturn(req, obj){

        return function (){

            if(req.request.readyState == 4){
                
                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    obj.exportCsvData(responseParsed);
                }
            }

            obj.loadingOut(obj.permalinkSearch_template.builtTemplate.querySelector("#permalinksBySearchByDate-results"));
        };
    }

    protected onGetAutoCompletePermalinksSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data){

                    obj.permalinkSearch_template.setpermalinksFilterItems(responseParsed.data);
                }
            });
        };
    }

    protected updateRows(rowsData) {
        
        this.permalinkSearch_template.setRowData(rowsData);
    }

    protected updateTotalRow(totalRow) {
        
        this.permalinkSearch_template.setTotalRow(totalRow);
    }

    protected updatePagination(totalCount) {

        this.permalinkSearch_template.updatePagination(totalCount);
    }

    protected updateIndicatorsData(indicatorsData): void{

        this.permalinkSearch_template.setIndicatorsData(indicatorsData);
    }

    protected exportCsvData(exportData): void{

        this.permalinkSearch_template.setCsvExportData(exportData);
        this.permalinkSearch_template.exportCsvData();
    }


     /**
     * Hook.
     *
     * Initiates data refresh.
     */
     public filterDropdownOnChange(element): void{

        this.getReportStatus();
        this.getPermalinksBySearchByDate();
        this.getPermalinksIndicatorsBySearchByDate();
    }

    protected filterDateOnChange(element) {

        this.getReportStatus();
        this.getSampledDates();
        this.permalinkSearch_template.setDatesSelected();
        this.getPermalinksBySearchByDate();
        this.getPermalinksIndicatorsBySearchByDate();
    }

    protected filterSimpleOnChange(){

        this.getReportStatus();
        this.getPermalinksBySearchByDate();
        this.getPermalinksIndicatorsBySearchByDate();
    }

    protected filterMultipleSelectorOnChange(){

        this.getReportStatus();
        this.getPermalinksBySearchByDate();
        this.getPermalinksIndicatorsBySearchByDate();
    }

    protected filterSingleGroupSelectorOnChange(){

        this.getReportStatus();
        this.getPermalinksBySearchByDate();
        this.getPermalinksIndicatorsBySearchByDate();
    }

    /**
     * Hook.
     *
     * Cancels data request.
     */
    protected filterSimpleCancel(){

        if(this.XHRHdl){

            this.XHRHdl.cancelAndReset();
        }
    }

    public getReportData(): void{

        this.getReportStatus();
        this.getPermalinksBySearchByDate();
        this.getPermalinksIndicatorsBySearchByDate();
    }

    protected setResultInfo(baseApiUrl, callIdentifier, totalCount, totalPage){

        let callHdl = this.getXHRHdl(baseApiUrl, callIdentifier);
        let execTime = Math.round((new Date().getTime() - callHdl.requestStartTime)/1000*100)/100;
        this.permalinkSearch_template.setResultInfo(totalCount, totalPage, execTime);
    }

    public updateFilterUrlWithoutCall(): void{

        let subViewModel = this.template.getViewModelForRequest();

        this.updateFilterUrl(null, subViewModel);
    }

    protected paginationOnPageClick(){

        this.getPermalinksBySearchByDate();
    }

    public onQuit(){

        for(let callKey in this.XHRHdls){

            this.XHRHdls[callKey].cancelAndReset();
        }
    }

    private getXHRHdl(baseURl, callIdentifier){

        let callKey =   baseURl + '-' + callIdentifier;

        return this.XHRHdls[callKey];
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = this.permalinkSearch_template.getViewModelForRequest();
        subViewModel['filters']['keyword'] = keyword;
        subViewModel['filters']['filterId'] = id;

        let usrReq_url = '/api/permalink_search/autoCompleteSuggestions/get/';

        let usrReq_callback;
        usrReq_callback = this.onGetMultipleAutoCompleteSuggestionsReturn.bind(this, id);

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteSuggestionsReturn(filterId, req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    (obj.permalinkSearch_template.setDynamicAutoCompleteMultiSelectFilterItems(filterId, responseParsed.data));
                }
            });
        };

    }


}


// WEBPACK FOOTER //
// ./js/modules/permalinkSearch.ts